var exports = {
  "kq": "minorTabSegment-d3ktc",
  "AQ": "minorTabMenu-d3ktc",
  "pL": "tabGroup-d3ktc",
  "DU": "floating-d3ktc",
  "xM": "horizontal-d3ktc",
  "Mn": "top-d3ktc",
  "sQ": "bottom-d3ktc",
  "j$": "menuItem-d3ktc",
  "Pf": "label-d3ktc",
  "Vd": "vertical-d3ktc",
  "wm": "logo-d3ktc",
  "gX": "center-d3ktc",
  "kb": "left-d3ktc",
  "pG": "right-d3ktc",
  "TQ": "labelsShown-d3ktc",
  "cH": "topTabs-d3ktc",
};

module.exports = exports;
